'use client'

import { TextInput } from 'flowbite-react'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useDebouncedCallback } from 'use-debounce'
import { useRef } from 'react'
import { isEmpty } from 'lodash'
import { IoClose, IoSearchOutline } from 'react-icons/io5'

export default function Search({
  onServer = false,
  placeholder,
}: {
  onServer?: boolean
  placeholder?: string
}) {
  let inputRef = useRef<HTMLInputElement>(null)
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const { replace } = useRouter()

  const handleSearch = useDebouncedCallback((term) => {
    const params = new URLSearchParams(searchParams)
    params.set('page', '1')
    if (term) {
      params.set('keyword', term)
    } else {
      inputRef.current!.value = ''
      params.delete('keyword')
    }

    if (onServer) {
      replace(`${pathname}?${params.toString()}`)
    } else {
      window.history.replaceState(null, '', `?${params.toString()}`)
    }
  }, 300)

  return (
    <div className="flex items-center relative lg:w-96 mt-6 md:mt-0 w-full">
      <TextInput
        ref={inputRef}
        type="text"
        icon={IoSearchOutline}
        className="w-full"
        placeholder={placeholder ? placeholder : 'Search'}
        onChange={(e) => {
          handleSearch(e.target.value)
        }}
        defaultValue={searchParams.get('keyword')?.toString()}
      />
      <div
        className={`${
          isEmpty(searchParams.get('keyword')) && 'hidden'
        } absolute top-0 right-1 mt-[13px] mr-2 cursor-pointer`}
        onClick={() => handleSearch('')}
      >
        <IoClose />
      </div>
    </div>
  )
}
